import type { ReactElement } from 'react';

import { ProtectedResourceId } from '@api/types/user/userAccessRights';

import { useGrantAccess } from '../logic/useGrantAccess';

type GrantAccessProps = {
  children: ReactElement;
  resourceId: ProtectedResourceId;
};

export const GrantAccess = ({ children, resourceId }: GrantAccessProps) => {
  const canDisplay = useGrantAccess({ resourceId });
  if (!canDisplay) {
    return null;
  }

  return children;
};
